import { supabase } from '../../supabase';
import { pkTodayKey } from '../../utils/pkTime';

function isRpcMissing(error) {
  const msg = String(error?.message || error || '').toLowerCase();
  return (
    msg.includes('could not find the function')
    || msg.includes('function public.get_admin_reports_page')
    || msg.includes('schema cache')
    || (msg.includes('get_admin_reports_page') && msg.includes('does not exist'))
  );
}

function isoDate(value) {
  const d = String(value || '').slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(d) ? d : null;
}

function mapMemberRow(row) {
  return {
    status: row.status || '',
    count: Number(row.count) || 0,
    newThisMonth: Number(row.newThisMonth ?? row.new_this_month) || 0,
    churned: Number(row.churned) || 0,
  };
}

function mapAttendanceRow(row) {
  return {
    branch: row.branch || 'Unassigned',
    checkIns: Number(row.checkIns ?? row.check_ins) || 0,
    avgDaily: Number(row.avgDaily ?? row.avg_daily) || 0,
    percentage: Number(row.percentage) || 0,
    memberCount: Number(row.memberCount ?? row.member_count) || 0,
  };
}

function mapRevenueRow(row) {
  return {
    month: row.month || '',
    memberships: Number(row.memberships) || 0,
    other: Number(row.other) || 0,
    total: Number(row.total) || 0,
  };
}

function mapMembershipRow(row) {
  return {
    package: row.package || '',
    active: Number(row.active) || 0,
    renewals: Number(row.renewals) || 0,
    revenue: Number(row.revenue) || 0,
  };
}

function mapTrainerRow(row) {
  return {
    trainer: row.trainer || '',
    members: Number(row.members) || 0,
    sessions: Number(row.sessions) || 0,
    rating: row.rating || '—',
  };
}

function mapProfitRow(row) {
  return {
    month: row.month || '',
    revenue: Number(row.revenue) || 0,
    expenses: Number(row.expenses) || 0,
    salaries: Number(row.salaries) || 0,
    profit: Number(row.profit) || 0,
  };
}

function mapBranchRow(row) {
  return {
    branch: row.branch || 'Unassigned',
    members: Number(row.members) || 0,
    revenue: Number(row.revenue) || 0,
    attendance: Number(row.attendance) || 0,
    trainers: Number(row.trainers) || 0,
  };
}

export async function fetchAdminReportsPageRpc({
  gymId,
  dateFrom = '',
  dateTo = '',
  branch = '',
  receptionistScope = false,
} = {}) {
  if (!gymId) return null;

  const today = pkTodayKey();
  const from = receptionistScope ? today : isoDate(dateFrom);
  const to = receptionistScope ? today : isoDate(dateTo);
  const branchValue = String(branch || '').trim();
  const pBranch = !branchValue || branchValue === 'all' ? null : branchValue;

  const { data, error } = await supabase.rpc('get_admin_reports_page', {
    p_gym_id: gymId,
    p_date_from: from,
    p_date_to: to,
    p_branch: pBranch,
    p_today: today,
  });

  if (error) {
    if (isRpcMissing(error)) return null;
    throw error;
  }
  const payload = typeof data === 'string'
    ? (() => { try { return JSON.parse(data); } catch { return null; } })()
    : data;
  if (!payload || payload.error) return null;

  return {
    memberReport: (payload.member_report || []).map(mapMemberRow),
    attendanceReport: (payload.attendance_report || []).map(mapAttendanceRow),
    revenueReport: (payload.revenue_report || []).map(mapRevenueRow),
    membershipReport: (payload.membership_report || []).map(mapMembershipRow),
    trainerReport: (payload.trainer_report || []).map(mapTrainerRow),
    profitReport: (payload.profit_report || []).map(mapProfitRow),
    branchReport: (payload.branch_report || []).map(mapBranchRow),
    memberOptions: [],
    fromRpc: true,
  };
}
